const Woolie = {
    productGallery:{
        init(productInfo) {
            const wrapper = document.querySelector('media-gallery');
            const wrapperVariants = productInfo.querySelector('.product-blocks__variant');
            if (!wrapper || !wrapperVariants) return;
            const wrapperImagesSelected = wrapper.querySelector('.media-gallery__items');
            const productImages = wrapper.querySelectorAll('.product__media-list li');

            if (!wrapperImagesSelected || !productImages.length) {
                return;
            }

            // A later variant replaces an earlier frame before it can remount.
            if (wrapper.woolieGalleryFrame) {
                cancelAnimationFrame(wrapper.woolieGalleryFrame);
                wrapper.woolieGalleryFrame = null;
            }
        
            // Server-side render: se o Liquid já montou os slides DESTA variante
            // (carimbo data-rendered-variant), só inicializa o Swiper.
            // Em troca de variante o carimbo difere -> rebuild via clone (fluxo original).
            const currentVariant = getSelectedVariant(wrapperVariants);
            const currentTitle = currentVariant && currentVariant.title ? currentVariant.title.toLowerCase() : null;
            const renderedTitle = wrapperImagesSelected.dataset.renderedVariant || null;
            if (currentTitle && renderedTitle === currentTitle && wrapperImagesSelected.children.length > 0) {
                wrapper.classList.remove('loading');
                initSlickSlider(wrapper.querySelector('.swiper--media-gallery'));
            } else {
                updateImagesForSelectedVariant();
            }

            function updateImagesForSelectedVariant() {
                const variantSelected = getSelectedVariant(wrapperVariants);
                setImagesVariantSelected((variantSelected?.title || '').toLowerCase());
            }
        
            function setImagesVariantSelected(option) {
                wrapper.classList.add('loading');

                const gallery = wrapper.querySelector('.swiper--media-gallery');
                if (gallery) window.WoolieCarousels.destroyWithin(gallery);
        
                const imagesSelected = Array.from(productImages).filter(item =>
                    item.getAttribute('data-image-alt') === option
                );

                // Rede de seguranca. O filtro casa o alt da foto com o titulo da
                // variante por igualdade exata, entao basta o alt estar cadastrado
                // fora do padrao para o resultado ser ZERO e a galeria ficar VAZIA:
                // medido nos Woolie Bites, 17 slides viram 0 ao trocar de variante
                // e o produto fica sem nenhuma foto. O Liquid em
                // product-media-gallery.liquid ja cai para "mostra todas" quando
                // nada casa (matched_count == 0); aqui essa protecao faltava, e por
                // isso o problema so aparecia DEPOIS do clique, nunca na carga.
                // Preferimos mostrar todas as fotos a nao mostrar nenhuma.
                const imagesToRender = imagesSelected.length > 0 ? imagesSelected : Array.from(productImages);

                wrapperImagesSelected.replaceChildren(...imagesToRender.map(item => item.cloneNode(true)));
                wrapperImagesSelected.dataset.renderedVariant = option;
                // Slides are already usable while the shared Swiper request is pending.
                wrapper.classList.remove('loading');
        
                wrapper.woolieGalleryFrame = requestAnimationFrame(() => {
                    wrapper.woolieGalleryFrame = null;
                    if (!wrapper.isConnected) return;
                    initSlickSlider(gallery);
                });
            }
        
            function initSlickSlider(element) {
                if (!element || (element.swiper && !element.swiper.destroyed)) return;
                const defaultOptions = {
                    navigation: {
                        nextEl: element.querySelector('.swiper-button-next'),
                        prevEl: element.querySelector('.swiper-button-prev'),
                    },
                    pagination: {
                        el: element.querySelector('.swiper-pagination'),
                        clickable: true,
                        type: 'bullets',
                    }
                };                
                window.WoolieCarousels.mount(element, defaultOptions, { immediate: true });
            }
        
            function getSelectedVariant(productInfoNode) {
                const selectedVariantData = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
                return selectedVariantData ? JSON.parse(selectedVariantData) : null;
            }
        }      
    },  
    productNotify: {
        init: function(){
            console.log('[MD] Notify Init')
            const submitButton = document.querySelector('.product-form__submit');
            if(submitButton === undefined){
                return;
            }
            if(document.querySelector('.product-form__submit').querySelector('span').getAttribute('data-button-label').trim() ===  window.variantStrings.soldOut || document.querySelector('.product-form__submit').querySelector('span').getAttribute('data-button-label').trim() ===  window.variantStrings.preorder_button_unavailable){
                submitButton.closest('.product-blocks__buy-button').classList.add('disabled');
                submitButton.closest('.product-blocks__buy-button').classList.remove('enabled');
            }else{
                submitButton.closest('.product-blocks__buy-button').classList.remove('disabled');
                submitButton.closest('.product-blocks__buy-button').classList.add('enabled');
            }
        }
    },  
    productInfo: {
        updatedSelectedVariant: function(variant){
            const wrapperSelectedVariant = document.querySelector('.js-selected-variant span');
            wrapperSelectedVariant.innerHTML = variant.title;
        }
    },
    cartFeaturedCollection:{
        init: function(){
            const addToCartButtons = document.querySelectorAll('[data-product-add]');
            addToCartButtons.forEach(button => {
                // init also runs after cart quantity changes; a retained upsell
                // button must never accumulate handlers or submit twice.
                if (button.dataset.woolieCartBound) return;
                button.dataset.woolieCartBound = 'true';
                button.addEventListener('click', async function(e) {
                    e.preventDefault();
                    if (button.disabled) return;
                    button.disabled = true;
                    button.querySelector('.text').classList.add('visibility-hidden');
                    button.querySelector('.loading__spinner').classList.remove('hidden');
                    let added = false;
                    try {
                        const productID = button.parentElement.parentElement.querySelector('select').value;
                        window.WoolieCart.invalidate();
                        const response = await fetch(routes.cart_add_url.replace(/\.js$/, '') + '.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                            body: JSON.stringify({
                                id: productID,
                                quantity: 1,
                                sections: ['cart-drawer', 'cart-icon-bubble'],
                                sections_url: window.location.pathname
                            })
                        });
                        // A 2xx with an unreadable response may already have
                        // mutated the cart. Recover by showing it, never retry.
                        added = response.ok;
                        const data = await response.json();
                        if (!response.ok || data.status) {
                            added = false;
                            throw new Error(data.description || 'Não foi possível adicionar o produto.');
                        }
                        if (window.location.pathname === routes.cart_url) {
                            window.location.reload();
                        } else {
                            await window.WoolieCart.renderDrawer(data);
                        }
                    } catch (error) {
                        console.error(error);
                        // The item already exists if only rendering failed. Show
                        // the current cart instead of encouraging another add.
                        if (added) window.location.assign(routes.cart_url);
                    } finally {
                        button.disabled = false;
                        button.querySelector('.text').classList.remove('visibility-hidden');
                        button.querySelector('.loading__spinner').classList.add('hidden');
                    }
                });
            });

            this.initSlider();
        },
        initSlider: function(){
            document.querySelectorAll('.js-cart-collection-content').forEach(element => {
                const collection = element.closest('.cart-collection');
                window.WoolieCarousels.mount(element, {
                    loop: element.querySelectorAll('.swiper-slide').length > 1,
                    slidesPerView: 1,
                    pagination: {
                        el: collection.querySelector('.swiper-pagination'),
                        clickable: true
                    },
                    navigation: {
                        nextEl: collection.querySelector('.swiper-button-next'),
                        prevEl: collection.querySelector('.swiper-button-prev')
                    },
                    autoplay: {
                        delay: 5000,
                        pauseOnMouseEnter: true,
                        disableOnInteraction: true
                    }
                }, { drawer: element.closest('cart-drawer') });
            });
        }
    },
    popup: {
        init: function(element, delay) {
			const popup = element;
			const closeBtn = document.getElementById('close-popup');

			// Abre só depois do primeiro sinal de engajamento (scroll/toque/mouse/tecla).
			// Sem interação, o popup não abre — evita que ele vire o LCP da página
			// e gere layout shift no carregamento (Core Web Vitals).
			const engagementEvents = ['scroll', 'pointerdown', 'mousemove', 'touchstart', 'keydown'];
			let armed = false;
			const arm = () => {
				if (armed) return;
				armed = true;
				engagementEvents.forEach(evt => window.removeEventListener(evt, arm));
				setTimeout(() => {
					this.show(popup);
				}, delay);
			};
			engagementEvents.forEach(evt => window.addEventListener(evt, arm, { passive: true }));

			closeBtn.addEventListener('click', () => {
				this.hide(popup);
			});
        },
        show: function(popup){
            popup.classList.add('visible');
            document.body.classList.add('overflow-hidden');
        },
        hide: function(popup) {
            popup.classList.remove('visible');
            document.body.classList.remove('overflow-hidden');
        }
    },
    cookie: {
        setCookie: function(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
        },
        getCookie: function(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
            return null;
        }	          
    },
    form: {
        date: {
            format: function(wrapper, placeholder, delay){
                setTimeout(function(){
                    var dateInput = wrapper.querySelector("#rd-date_field-lvfb0ove");
            
                    dateInput.placeholder = placeholder;
            
                    dateInput.addEventListener("focus", function () {
                        this.type = "date";
                    });
            
                    dateInput.addEventListener("blur", function () {
                        if (!this.value) {
                            this.type = "text";
                            this.placeholder = placeholder;
                        }
                    });
            
                    if (!dateInput.value) {
                        dateInput.type = "text";
                    }
                }, delay);
            }
        }
    },
    setHeight: {
        init: function(wrapper, groupSize = Infinity) {
            const swiperContainer = document.querySelector(wrapper);
            const slides = Array.from(swiperContainer.querySelectorAll('.card-information__content.top'));
            const prices = Array.from(swiperContainer.querySelectorAll('.price'));
        
            function applyMaxHeight(elements) {
                for (let i = 0; i < elements.length; i += groupSize) {
                    let maxHeight = 0;
                    const group = elements.slice(i, i + groupSize);
        
                    group.forEach(element => {
                        const elementHeight = element.offsetHeight;
                        if (elementHeight > maxHeight) {
                            maxHeight = elementHeight;
                        }
                    });
        
                    group.forEach(element => {
                        element.style.height = `${maxHeight}px`;
                    });
                }
            }
        
            applyMaxHeight(slides);
            applyMaxHeight(prices);
        },
        
        handleResize: function(wrapper) {
            const groupSize = window.innerWidth < 989 ? 2 : 4;
            Woolie?.setHeight?.init(wrapper, groupSize);
        },
        
        setupResizeListener: function(wrapper) {
            window.addEventListener('resize', Woolie.setHeight.handleResize(wrapper));
            Woolie.setHeight.handleResize(wrapper);
        }                        
    }
}
